import { Component, OnInit, OnDestroy } from '@angular/core';
import { Params, Router, ActivatedRoute } from '@angular/router';
import { RouteHelperService } from '../../core/services/route-helper.service';
import { LocationService } from '../services/location.service';
import { BaseEditComponent } from '../../core/common/base-component';
import { FormUtil } from '../../core/form.util';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'ch-location-edit',
  templateUrl: './location-edit.component.html',
  styleUrls: ['./location-edit.component.css'],
})
export class LocationEditComponent extends BaseEditComponent implements OnInit, OnDestroy {
  private static readonly londonLat = 51.5074;
  private static readonly londonLng = 0.1278;

  private locationId: string;
  public locationData: any = {};
  public locationName: string;
  public editMode: boolean;
  public isCountryCh: boolean;
  private type: string;
  private parentId: string;

  public errors: any = {};

  public initialLat: number = LocationEditComponent.londonLat;
  public initialLng: number = LocationEditComponent.londonLng;
  public chosenLocation = false;

  public breadcrumb: any[] = [];

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private locationService: LocationService,
    private routeHelperService: RouteHelperService,
    private titleService: Title,
  ) {
    super();
  }

  ngOnInit() {
    this.activatedRoute.queryParamMap
      .map((params: Params) => params.params)
      .subscribe(params => {
        this.editMode = this.routeHelperService.isCurrentPageEdit();
        this.locationId = params.id;
        this.parentId = params.parentId;

        if (this.editMode) {
          this.fetchData(this.locationId);
          this.setLocationBreadcrumb(this.locationId);
        } else {
          this.titleService.setTitle(`New Location | CODE Hospitality CMS`);
          this.type = 'string' === typeof params.type ? params.type.trim().toLowerCase() : '';
          this.setLocationBreadcrumb(this.parentId, 'Add');
        }
      });
  }

  ngOnDestroy() {
    this.titleService.setTitle(`CODE Hospitality CMS`);
  }

  private setLocationBreadcrumb(id: string, last?: string) {
    if (!id) {
      this.breadcrumb = ['Locations', this.editMode ? '' : 'Add New'];
      return;
    }

    this.locationService.getLocationParentTree(id).then((resp: any[]) => {
      if (last) {
        resp.push(last);
      }

      const a = ['Locations', ...resp];
      const result = [];

      for (let i = 0; i < a.length; i++) {
        const item = a[i];
        if ('object' === typeof item) {
          result.push({
            name: item.name,
            data: item.id,
          });
        } else {
          result.push(
            0 === i
              ? {
                name: item,
                data: 'top',
              }
              : item
          );
        }
      }

      this.breadcrumb = result;
    });
  }

  public breadcrumbGoTo(data) {
    if ('top' === data) {
      this.router.navigate(['/admin/locations']);
    } else {
      this.goToSubroute(data);
    }
  }

  public goToSubroute(id: string) {
    this.router.navigate(['/admin/locations'], {
      queryParams: { parentId: id },
    });

    return false;
  }

  private fetchData(id: string) {
    this.loading = true;
    this.locationService.getLocation(id).subscribe(
      data => {
        this.locationData = data.json();
        this.locationName = this.locationData['name'];
        this.titleService.setTitle(`${this.locationName} | Locations | CODE Hospitality CMS`);
        this.type = this.locationData.isCountry ? 'country' : this.locationData.isCity ? 'city' : '';

        if (this.locationData.isCountry) {
          this.locationData.countryName = this.locationData.nameEn;
        } else {
          this.locationData.cityName = this.locationData.nameEn;
        }

        if (this.locationData.latitude && this.locationData.longitude) {
          this.initialLat = this.locationData.latitude;
          this.initialLng = this.locationData.longitude;
          this.chosenLocation = true;
        }
      },
      () => { },
      () => {
        this.loading = false;
        this.loaded = true;
      }
    );
  }

  public edit(form) {
    if (!FormUtil.isValid(form)) {
      return;
    }

    const reqData: any = { ...this.locationData };

    reqData.nameEn = this.locationData.isCity ? this.locationData.cityName : this.locationData.countryName;

    if (this.parentId) {
      reqData.parentLocationId = this.parentId;
    }

    delete reqData.cityName;
    delete reqData.countryName;

    const methodName = this.editMode ? 'updateLocation' : 'addLocation';

    if ('boolean' !== typeof reqData.isCity) {
      reqData.isCity = false;
    }
    if ('boolean' !== typeof reqData.isCountry) {
      reqData.isCountry = false;
    }

    this.loading = true;
    this.locationService[methodName](reqData).subscribe(
      _ => {
        this.loading = false;
        this.cancel();
      },
      err => {
        this.loading = false;
        if (!(err.errors instanceof Array)) {
          return;
        }
        err.errors.forEach(item => {
          this.errors[item.field] = item.message;
        });
      }
    );
  }

  public cancel() {
    const targetLocationId = this.editMode ? this.locationData.parentLocationId : this.parentId;
    const url = '/admin/locations' + (targetLocationId ? '?parentId=' + targetLocationId : '');
    this.router.navigateByUrl(url);
  }

  public markAsCity(checked) {
    this.locationData.isCity = checked;
    this.locationData.isCountry = false;
    if (!checked) {
      this.locationData.cityName = '';
    }
  }

  public markAsCountry(checked) {
    this.locationData.isCountry = checked;
    this.locationData.isCity = false;
    if (!checked) {
      this.locationData.countryName = '';
    }
  }

  public onLocationChange(event: any) {
    this.locationData.latitude = event.coords.lat;
    this.locationData.longitude = event.coords.lng;

    this.chosenLocation = true;
  }

  public delete() {
    if (!confirm('Are you sure you want to delete this location ?')) {
      return;
    }

    this.locationService.deleteLocation(this.locationId).subscribe(resp => {
      this.cancel();
    });
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/locations/location-edit/location-edit.component.ts